// Shared copy for API errors from member / booking player name validation (blacklist etc.)

export const PLAYER_NAME_FORBIDDEN_TOAST_DE =
  'Spielername enthält einen nicht erlaubten Begriff';

export function isPlayerNameForbiddenWordApiError(error) {
  return String(error?.code || '').trim() === 'PLAYER_NAME_FORBIDDEN_WORD';
}
